<template>
  <div>
    <Toolbar :title="t('Persons')"></Toolbar>

    <v-card-text>
      <div>Kopiuj do schowka:</div>
      <v-btn @click="all">Wszystkie osoby w grupach otwartych</v-btn><br />
      <v-btn @click="members">Członkowie grup otwartych</v-btn><br />
      <v-btn @click="leaders">Członkowie grup liderskich</v-btn>
      <v-btn @click="emails('L')">Emaile liderów otwartych grup</v-btn>
      <v-btn @click="emails('L', 'AL')">Emaile liderów otwartych grup wraz zastępcami</v-btn>
      <!-- <v-btn @click="emails('SL')">Emaile liderów sekcyjnych</v-btn>
      <v-btn @click="emails('SL', 'ASL')">Emaile liderów sekcyjnych wraz z zastąpcami</v-btn> -->
    </v-card-text>
  </div>
</template>

<script>
import Toolbar from '@/components/layout/Toolbar'
import data from '@/data'
import u from '@/util'
import { roleFullNames } from '@/global'
import { t } from '@/i18n'

const member = r => ['M', 'SP', 'AL', 'L', 'ASL', 'SL'].includes(r)

export default {
  components: { Toolbar },

  methods: {
    async all() {
      this.copyFiltered((p, i) => {
        const cell = this.$store.state.cell.cells[p.cell]
        return cell && !cell.archived && cell.type === 'O'
      })
    },
    async members() {
      this.copyFiltered((p, i) => {
        const cell = this.$store.state.cell.cells[p.cell]
        return cell && !cell.archived && cell.type === 'O' && member(p.role)
      })
    },
    async leaders() {
      this.copyFiltered((p, i) => {
        const cell = this.$store.state.cell.cells[p.cell]
        return cell && !cell.archived && cell.type === 'L' && member(p.role)
      })
    },
    async copyFiltered(filter) {
      const assignments = await data.assignments2.findAll()
      console.log(assignments)
      const persons = (filter ? assignments.filter(filter) : assignments)
        .filter(p => !this.$store.state.cell.cells[p.cell].archived)
        .map(p => {
          const cellName = this.$store.getters['cell/cellDesc'](p.cell)
          const cell = this.$store.state.cell.cells[p.cell]
          const section = cell && this.$store.getters['cell/cellDesc'](cell.parent)
          const role = t(roleFullNames[p.role])
          return [p.person, role, cellName, section]
        })
        .sort(u.comparator[0])
      const rows = [['Osoba', 'Rola', 'Grupa', 'Sekcja']].concat(persons)
      u.copyTextToClipboard(rows.map(row => row.join('\t')).join('\n'))
      this.$store.commit('snackbar', 'Skopiowano do schowka', {
        root: true,
      })
    },
    async emails(...roles) {
      const usersByRoles = await Promise.all(roles.map(role => data.users.getEmailsByRole(role)))
      const users = usersByRoles.reduce((a, c) => ({ ...a, ...c }), {})
      const emails = Object.keys(users)
        .filter(email => {
          console.log('***', email, users[email].cell, this.$store.state.cell.cells[users[email].cell])
          return !this.$store.state.cell.cells[users[email].cell].archived
        })
        .map(email => email.replace(/\*/g, '.'))

      u.copyTextToClipboard(emails.flat(1).join(', '))
      this.$store.commit('snackbar', 'Skopiowano do schowka', {
        root: true,
      })
    },
  },
}
</script>
